import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/saas-subscription'),
      component: SettingsWrapper,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: '',
          name: 'saas_subscription_settings',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
